<template>
  <div>
    <transition :name="$store.state.isLayoutSwitched ? 'slide-in-down' : 'slide-in-up'">
      <div class="bottom-bar" v-show="$store.state.isBottomBarVisible">
        <div v-if="styles['general']['show-layout-switch-toggle']" class="bottom-bar__layout-toggle">
          <button class="touch" @click="$store.commit('SET_IS_LAYOUT_SWITCHED', !$store.state.isLayoutSwitched)">
            <fa :icon="['fas', 'sync']"/>
          </button>
        </div>
        
        <div class="bottom-bar__main touch" @click.self="navigateToDefaultPage">

          <a 
            v-if="$store.state.selector"
            href="http://localhost:9000"
            class="selector-btn touch"
            :dir="language.rtl ? 'rtl' : 'ltr'"
          >
            <span>{{ labels.exploreCommunities[language.code] || labels.exploreCommunities['en'] }}</span>
          </a>

          <button
            tag="span"
            class="btn btn--home touch"
            style="position: absolute; top: 1.9rem; left: 4.85rem;"
            @click="navigateHome"
          >
            <div class="btn__icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" fill="currentColor">
                <path
                  d="M303.5 13.7L288 .5 272.5 13.7l-264 224 31.1 36.6L64 253.5 64 488l0 24 24 0 400 0 24 0 0-24 0-234.5 24.5 20.8 31.1-36.6-264-224zM112 464l0-251.2L288 63.5 464 212.8 464 464l-80 0 0-168 0-24-24 0-144 0-24 0 0 24 0 168-80 0zm128 0l0-144 96 0 0 144-96 0z"
                />
              </svg>
            </div>
          </button>

          <router-link 
            :to="defaultPage"
            tag="span"
            class="btn--back touch"
            style="position: absolute; top: 1.9rem; left: 9.8rem;"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="currentColor">
              <path
                d="M18.2 273l-17-17 17-17L171.8 85.4l17-17 33.9 33.9-17 17L93.1 232 424 232l24 0 0 48-24 0L93.1 280 205.8 392.6l17 17-33.9 33.9-17-17L18.2 273z"
              />
            </svg>

            <div>back</div>
          </router-link>

          <transition-group
            class="bottom-bar__nav-items"
            :class="{ 'dir-rtl' : language.rtl }"
            @before-enter="beforeEnter"
            @enter="enter"
            @afterEnter="afterEnter"
            @leave="leave"
          >             
            <div
              v-for="(item, index) in activeNavItems"
              class="bottom-bar__nav-item-wrapper"
              :class="[
                { 'bottom-bar__nav-item-wrapper--active': isNavItemActive(item) },
                { 'bottom-bar__nav-item-wrapper--last-item' : item.isLiveSection }
              ]"
              :data-index="index"
              :key="item._id"
              :dir="language.rtl ? 'rtl' : 'ltr'"
            >
              <router-link 
                class="btn bottom-bar__nav-item touch"
                :class="[
                  { 'router-link-active': isNavItemActive(item) },
                  { 'btn--live': item.isLiveSection }
                ]"
                tag="button"
                :to="getItemLink(item)"
                :style="isNavItemActive(item) ? buttonStylesActive : buttonStyles"
                @click.native="triggerMedia(item.label['en']); playClickSound(); bus.$emit('navClick')"
              >
                <span class="bottom-bar__nav-label" v-html="item.label[language.code] || item.label['en']"></span>
              </router-link>
            </div>
          </transition-group>
        </div>

        <div class="bottom-bar__sub">
          <router-link
            v-if="styles['general']['show-favourites'] === true" 
            class="btn btn--favourite touch"
            :active-class="viewFavouriteLink !== '' ? 'router-link-active' : ''"
            tag="button"
            :to="viewFavouriteLink"
          >
            <div class="btn__icon">
              <fa :icon="['far', 'heart']" />
            </div>
          </router-link>

          <div v-if="languages.length > 1" class="bottom-bar__language-selector">
            <div
              v-for="lang in languages"
              class="bottom-bar__language-selector-button touch"
              :class="{
                'bottom-bar__language-selector-button--active': lang.code === language.code,
                'na': lang.code === 'ar'
              }"
              :key="lang.code"
              @click="setLanguage(lang)"
            >
              <div>
                {{ lang.code }}
              </div>
            </div>
          </div>

          <span>
            <img class="bottom-bar__sensoreal-logo touch" src="/assets/sensoreal.png" @click="forceRefresh()">
          </span>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import _ from 'lodash'
import { bus } from '../main'

export default {
  props: ['nav-items'],

  data () {
    return {
      activeNavItems: [],
      bus: bus
    }
  },

  computed: {
    ...mapState({
      labels: 'labels'
    }),

    ...mapGetters({
      activePage: 'activePage',
      backlink: 'activeBackLink',
      favourites: 'favourites/favourites',
      viewFavouriteLink: 'favourites/viewFavouritesLink',
      languages: 'languages',
      language: 'language',
      styles: 'styleTemplate'
    }),

    env () {
      return process.env
    },

    defaultPage () {
      const categoryId = this.$store.state.route.params.categoryId
      const navigation = _.find(this.$store.state.navigation, navigation => {
        return navigation._id === this.$store.state.route.params.categoryId
      })
      
      if (navigation) {
        return navigation.defaultChildUrl ? navigation.defaultChildUrl : `/category/${categoryId}/page/${navigation.children[0].pageId}`
      }

      return '/'
    },

    favouritesButtonLabel () {
      switch (this.language.code) {
        case 'en':
          return 'View Favourites'
        case 'ar':
          return 'عرض المفضلة'          
        default:
          return 'View Favourites'
      }
    },

    buttonStyles () {
      return {

      }
    },

    buttonStylesActive () {
      return {

      }
    },
  },

  watch: {
    navItems: {
      handler (oldNavItems, newNavItems) {
        if (!_.isEqual(oldNavItems, newNavItems)) {
          if (oldNavItems.length) {
            this.activeNavItems = []
          }

          this.$store.commit('addAnimationToQueue', 'BottomBar')
        }
      },
      immediate: true
    }
  },

  mounted () {
    bus.$on('animateBottomBar', () => {
      if (!_.isEqual(this.activeNavItems, this.navItems)) {
        this.activeNavItems = this.navItems
      } else {
        bus.$emit('finishedAnimation')
      }
    })
  },

  methods: {
    ...mapActions([
      //'triggerVideo',
      'playClickSound'
    ]),

    triggerMedia (pageName) {
      if (!pageName) return this.$store.dispatch('triggerVideo', 'default')
      const formattedPageName = pageName.toLowerCase().replaceAll(' ', '-')
      this.$store.dispatch('triggerVideo', `${process.env.VUE_APP_PROJECT}_${formattedPageName}.mp4`)
    },

    navigateHome () {
      if (this.$store.state.homeUrl) return window.location.href = this.$store.state.homeUrl
      this.$router.push(this.defaultPage)
    },

    beforeEnter (el) {
      el.style.opacity = 0
      el.style.transform = 'translateY(25%)'
    },

    enter (el, done) {
      setTimeout(() => {
        el.style.opacity = 1
        el.style.transform = 'translateY(0)'
        el.style.transition = `transform 0.6s cubic-bezier(0.33, 1, 0.68, 1), opacity 1.2s`
        done()
      }, (parseInt(el.dataset.index) + 1) * 150)
    },

    afterEnter (el) {
      if (parseInt(el.dataset.index) + 1 === this.navItems.length) {
        bus.$emit('finishedAnimation')
      } 
    },    

    leave (el) {
      el.style.opacity = 0
      el.style.transform = 'translateY(25%)'
      el.style.transition = `transform 0.4s cubic-bezier(0.32, 0, 0.67, 0), opacity 0.3s`
    },

    getItemLink (item) {
      if (item.customRoute) {
        return item.customRoute
      }

      return `/category/${this.$store.state.route.params.categoryId}/page/${item.pageId}`
    },

    isNavItemActive (item) {
      if (item.customRoute) {

        if (this.$route.path.includes(item.customRoute)) {
          return true
        }
      }
      
      return this.activePage && (item.pageId === this.activePage._id || _.find(item.children, child => {
        return child.pageId === this.activePage._id
      }))
    },

    forceRefresh () {
      // this.triggerMedia()
      if (this.$store.state.homeUrl) {
        const url = new URL(this.$store.state.homeUrl);
        window.location.href = url.origin
      } else {
        window.location.href = window.location.origin
      }      
    },

    navigateToDefaultPage () {
      this.$router.push(this.defaultPage).catch(() => {})
    },

    setLanguage (lang) {
      this.$store.commit('SET_LANGUAGE', lang)
      setTimeout(() => {
        bus.$emit('startAnimations')
      }, 100)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/styles/_mixins.scss";
@import "@/styles/_variables.scss";
@import "@/styles/_buttons.scss";

.bottom-bar {
  bottom: 0;
  left: 0;
  display: flex;
  position: absolute;
  width: 100%;
  z-index: 110;

  .layout-switched & {
    bottom: initial;
    top: 0;
  }

  &__language-selector {
    display: flex;
    gap: 1.15rem;
    position: relative;
    top: 0;
    left: 0;
    z-index: 1000;
  }

  &__language-selector-button {
    border: 0.1rem solid white;
    border-radius: 0.5rem;
    height: 3.75rem;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 3.75rem;
    line-height: 2.2rem;
    text-align: center;
    text-transform: uppercase;
    opacity: 0.5;

    &--active {
      opacity: 1;
    }
  }

  &__layout-toggle {
    opacity: 0.5;
    position: absolute;
    bottom: 0.5rem;
    left: 0.5rem;
    z-index: 1000;

    button {
      font-size: 1.6rem;
    }

    .layout-switched & {
      bottom: initial;
      left: 0.5rem;
      top: 0.5rem;
    }
  }

  &__main {
    align-items: center;
    background-color: $bottombar-bg-color;
    bottom: 0;
    display: flex;
    flex-grow: 1;
    height: 10rem;
    justify-content: center;
    padding: 1.9rem 0;
  }

  &__sub {
    align-items: flex-start;
    background-color: $bottombar-bg-color;
    display: flex;
    justify-content: flex-end;
    padding: 1.9rem 7.9rem 1.9rem 5rem;
    position: relative;
    width: 32.5rem;
    .layout-switched & {
      align-items: flex-end;
    }    

    .layout-switched & {
      align-items: flex-end;
    }    

    .btn {
      margin: 0 auto 0 0;

      &--inactive {
        opacity: .15;
      }
    }
  }

  &__nav-items {
    align-self: flex-start;
    display: flex;
    flex-grow: 1;
    justify-content: center;
    margin-right: 8.5rem;

    .layout-switched & {
      align-self: flex-end;
    }        
  }

  &__nav-item-wrapper {
    display: flex;

    &--last-item {
      margin-left: 4rem;
      padding: 0 4rem;
      position: absolute;
      right: 32.5rem;

      .bottom-bar__nav-item {
        margin: 0;
      }

      .btn--live.router-link-active {
        // color: $white;
      }

      &::after {
        background: #4d555b;
        content: '';
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
        width: .1rem;
      }

      &::before {
        background: #4d555b;
        content: '';
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        width: .1rem;
      }
    }
  }

  &__nav-item {
    margin: 0 1rem;

    &.router-link-active, &--active {
      color: $black;
    }
  }

  .selector-btn {
    position: absolute;
    left: 5rem;
    bottom: 3.2rem;
    display: block;
    border: 0.01rem solid #fff;
    border-radius: .5rem;
    font-size: 1rem;
    opacity: .6;
    padding: .5rem .6rem .4rem;
    margin-left: -0.3rem;
    text-align: center;
    text-transform: uppercase;
  }

  &__sensoreal-logo {
    position: absolute;
    bottom: 1rem;
    right: 7.9rem;
    width: 8.65rem;
    z-index: 1;
  }

  &__version {
    color: rgba(255, 255, 255, 0.25);
    display: block;
    text-align: right;
  }
}
</style>